import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { ListQuote } from "../../types/Quote";

export const getListQuote = (quoteId: string, options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["list-quote", quoteId],
    queryFn: (): Promise<ListQuote> => {
      return fetchWithAuth<ListQuote>("getListQuote", quoteId);
    },
    enabled: isQueryEnabled(options),
  });
};
